import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state = () => ({
  user: {},
  organisation: {},
  organisations: [],
  invites: [],
  wallet: {},
  switch_key: null
});

export default {
  state,
  getters,
  actions,
  mutations
};
